import merge from 'lodash.merge'
import { buildBaseOptions } from '../base_options'

export const SimpleBarVariant = {
  chartType: 'bar',

  applyDataDefaults(datasets) {
    datasets.forEach((dataset) => {
      dataset.borderRadius ??= 0
      dataset.borderSkipped ??= false
      dataset.barThickness ??= 70
    })
  },

  buildOptions(options = {}) {
    const base = buildBaseOptions(options)

    return merge({}, base, {
      scales: {
        x: {
          type: 'category',

          grid: {
            display: false,
          },
        },
      },
    })
  },
}
